import React from "react";
import {Screen} from "../components/layout";
import {login} from "../../actions/session";
import * as forms from "../utils/forms";
import MobileLayout from "../components/mobile/layout";
import M from "../../strings";
import { MobileInput, MobilePasswordInput } from "../components/mobile/forms";
import * as ui from "../utils/ui";

export default class Login extends Screen {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }

    login(e) {
        e && e.preventDefault();
        const data = forms.serialize(this.formRef.current);
        login(data)
            .then(() => window.location.reload())
    }

    render() {
        return(
            <MobileLayout
                hideHeader={true}
            >
                <div
                    className="container"
                >
                    <div
                        className="row justify-content-center"
                    >
                        <div
                            className="login__wrapper col-12 col-md-8 col-lg-6"
                        >
                            <div
                                className="login__logo"
                            >
                                <img
                                    src="resources/images/logo.svg"
                                />
                            </div>
                            <h4
                                className="login__header"
                            >
                                {M("welcomeBack")}
                            </h4>
                            <form
                                ref={this.formRef}
                                className="login__form"
                                action=""
                                onSubmit={this.login.bind(this)}
                            >
                                <MobileInput
                                    type="email"
                                    name="mail"
                                    autoComplete="username"
                                    label={M("mailAddress")}
                                    placeholder={M("mailAddress")}
                                />
                                <MobilePasswordInput
                                    name="password"
                                    autoComplete="current-password"
                                    label={M("password")}
                                    placeholder={M("password")}
                                />
                                <div
                                    className="login__action-link"
                                >
                                    <a
                                        href="#/recover"
                                    >
                                        {M("forgotPassword")}
                                    </a>
                                </div>
                                <div
                                    className="login__btn"
                                >
                                    <button
                                        type="submit"
                                        className="btn btn-block btn-primary"
                                    >
                                        {M("loginBtnText")}
                                    </button>
                                </div>
                                {/* <div
                                    className="login__register"
                                >
                                    {M("notRegistered")} <a href="#/register">{M("registerNow")}</a>
                                </div> */}
                            </form>
                        </div>
                    </div>
                </div>
            </MobileLayout>
        )
    }
}